import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';

import EditIcon from '@material-ui/icons/Edit';
import DateRangeIcon from '@material-ui/icons/DateRange';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(() => ({
  textRight: {
    textAlign: 'right',
  },
  serviceList: {
    color: '#212B36',
    marginBottom: 8,
  },
  listLabel: {
    fontWeight: '500',
    color: '#637381',
    marginTop: '24px',
  },
  pointIcon: {
    cursor: 'pointer',
    color: '#637381',
    width: 16.67,
    height: 16.67,
  },
  titleMargin: {
    marginBottom: 10,
  },
  mainBox: {
    marginBottom: 24,
    '& h5': {
      fontWeight: 700,
    },
  },
  subtitle: {
    color: '#637381',
  },
  noteDetail: {
    marginTop: 24,
    borderRadius: 8,
    border: '1px solid rgba(145, 158, 171, 0.2)',
    padding: 15,
    '& p': {
      color: '#919EAB',
    },
  },
  boxMargin: {
    marginBottom: 24,
    marginLeft: 15,
  },
  iconMargin: {
    marginRight: 16,
    color: '#637381',
  },
  noteField: {
    width: '100%',
    marginBottom: 24,
    background: 'rgba(145, 158, 171, 0.08)',
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
    },
  },
  noteAddBtn: {
    float: 'right',
    borderRadius: 8,
    padding: '8px 12px',
    color: '#ffffff',
    fontWeight: 600,
    backgroundColor: '#212B36',
  },
  mainLabel: {
    color: '#000000',
    fontWeight: 600,
    marginBottom: 16,
  },
  notesLabel: {
    marginTop: '24px',
  },
}));

let customerNotesCount = 0;
let internalNotesCount = 0;

const UnifiedViewNotes = ({
  admin_note,
  customer_diagnostic_note,
  customer_schedule_note,
  customer_note,
  customer_tire_note,
  vehicle_service_requirements_note,
  customer_home_additional_note,
  key_exchange_note,
  technician_note,
  payment_note,
  setIsEditing,
  companyname,
}) => {
  const classes = useStyles();
  useEffect(() => {
    const customerNotes = [
      customer_note,
      customer_diagnostic_note,
      customer_schedule_note,
      customer_tire_note,
      vehicle_service_requirements_note,
      customer_home_additional_note,
      key_exchange_note,
      payment_note,
    ];
    const internalNotes = [admin_note, technician_note, payment_note];
    customerNotesCount = customerNotes.reduce((acc, item) => {
      return item ? acc + 1 : acc;
    }, 0);
    internalNotesCount = internalNotes.reduce((acc, item) => {
      return item ? acc + 1 : acc;
    }, 0);
  });
  return (
    <>
      <Grid container spacing={0} className={classes.titleMargin}>
        <Grid item xs={10} sm={10} md={10}>
          <Box display="flex" alignItems="center" flexWrap="wrap">
            <Box mr={2} className={classes.mainBox}>
              <Typography variant="h5" gutterBottom>
                Notes
              </Typography>
              <Typography variant="body2" className={classes.subtitle}>
                Notes are not shared with the customer
              </Typography>
            </Box>
            {/* <Box className={classes.noteDetail}>
              <Typography variant="body2">
                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
              </Typography>
            </Box>
            <Box display="flex" my={1} className={classes.boxMargin}>
              <Box>
                <DateRangeIcon className={classes.iconMargin} />
              </Box>
              <Box>
                <Typography variant="body2" className={classes.listColor}>
                  <span className={classes.listLabel}>7:45am on 07/21/2023</span>
                </Typography>
                
              </Box>
            </Box>
            <Grid item xs={12} sm={12} md={12}>
              <TextField
                id="note"
                label="Add a Note"
                multiline
                rows={4}
                variant="outlined"
                className={classes.noteField}
              />
              <Box>
                <Button variant="contained" className={classes.noteAddBtn}>Add</Button>
              </Box>
            </Grid> */}
          </Box>
        </Grid>
        <Grid item xs={2} sm={2} md={2} className={classes.textRight}>
          <EditIcon
            fontSize="inherit"
            className={classes.pointIcon}
            onClick={() => setIsEditing((prev) => !prev)}
          />
        </Grid>
      </Grid>

      <Grid container spacing={0}>
        {customerNotesCount > 0 && (
          <Grid item md={6}>
            <Typography variant="body2" gutterBottom>
              {customerNotesCount} Customer Note
              {customerNotesCount > 1 && 's'}
            </Typography>
          </Grid>
        )}
        {internalNotesCount > 0 && (
          <Grid item md={6}>
            <Typography variant="body2" gutterBottom>
              {internalNotesCount} Internal Note
              {internalNotesCount > 1 && 's'}
            </Typography>
          </Grid>
        )}
        {customerNotesCount > 0 && (
          <Grid item md={6}>
            <Typography variant="body2" className={classes.serviceList}>
              <u>
                <span className={classes.mainLabel}>Customer Provided: </span>
              </u>
            </Typography>
            <Box>
              {companyname && (
                <>
                  <Typography
                    variant="body2"
                    className={`${classes.serviceList} ${classes.notesLabel}`}
                  >
                    <span className={classes.listLabel}>Company Name: </span>
                  </Typography>
                  <Typography variant="body2" className={classes.serviceList}>
                    {companyname}
                  </Typography>
                </>
              )}
            </Box>
            <Box>
              {customer_note && (
                <>
                  <Typography
                    variant="body2"
                    className={`${classes.serviceList} ${classes.notesLabel}`}
                  >
                    <span className={classes.listLabel}>General Note: </span>
                  </Typography>
                  <Typography variant="body2" className={classes.serviceList}>
                    {customer_note}
                  </Typography>
                </>
              )}
            </Box>
            <Box>
              {customer_tire_note && (
                <>
                  <Typography
                    variant="body2"
                    className={`${classes.serviceList} ${classes.notesLabel}`}
                  >
                    <span className={classes.listLabel}>Tire Note: </span>
                  </Typography>
                  <Typography variant="body2" className={classes.serviceList}>
                    {customer_tire_note}
                  </Typography>
                </>
              )}
            </Box>
            <Box>
              {customer_diagnostic_note && (
                <>
                  <Typography
                    variant="body2"
                    className={`${classes.serviceList} ${classes.notesLabel}`}
                  >
                    <span className={classes.listLabel}>Diagnotics Note: </span>
                  </Typography>
                  <Typography variant="body2" className={classes.serviceList}>
                    {customer_diagnostic_note}
                  </Typography>
                </>
              )}
            </Box>
            <Box>
              {customer_schedule_note && (
                <>
                  <Typography
                    variant="body2"
                    className={`${classes.serviceList} ${classes.notesLabel}`}
                  >
                    <span className={classes.listLabel}>Schedule Note: </span>
                  </Typography>
                  <Typography variant="body2" className={classes.serviceList}>
                    {customer_schedule_note}
                  </Typography>
                </>
              )}
            </Box>
            <Box>
              {key_exchange_note && (
                <>
                  <Typography
                    variant="body2"
                    className={`${classes.serviceList} ${classes.notesLabel}`}
                  >
                    <span className={classes.listLabel}>
                      Key Exchange Note:{' '}
                    </span>
                  </Typography>
                  <Typography variant="body2" className={classes.serviceList}>
                    {key_exchange_note}
                  </Typography>
                </>
              )}
            </Box>
            <Box>
              {vehicle_service_requirements_note && (
                <>
                  <Typography
                    variant="body2"
                    className={`${classes.serviceList} ${classes.notesLabel}`}
                  >
                    <span className={classes.listLabel}>
                      Vehicle Service Requirements Note:
                    </span>
                  </Typography>
                  <Typography variant="body2" className={classes.serviceList}>
                    {vehicle_service_requirements_note}
                  </Typography>
                </>
              )}
            </Box>
            <Box>
              {customer_home_additional_note && (
                <>
                  <Typography
                    variant="body2"
                    className={`${classes.serviceList} ${classes.notesLabel}`}
                  >
                    <span className={classes.listLabel}>
                      Customer Home Note:{' '}
                    </span>
                  </Typography>
                  <Typography variant="body2" className={classes.serviceList}>
                    {customer_home_additional_note}
                  </Typography>
                </>
              )}
            </Box>
          </Grid>
        )}
        {internalNotesCount > 0 && (
          <Grid item md={6}>
            <Typography
              variant="body2"
              className={classes.serviceList}
            >
              <u>
                <span className={classes.mainLabel}>Employee Provided: </span>
              </u>
            </Typography>
            <Box>
              {admin_note && (
                <>
                  <Typography
                    variant="body2"
                    className={`${classes.serviceList} ${classes.notesLabel}`}
                  >
                    <span className={classes.listLabel}>
                      Admin Note (not visible to customer):{' '}
                    </span>
                  </Typography>
                  <Typography variant="body2" className={classes.serviceList}>
                    {admin_note}
                  </Typography>
                </>
              )}
            </Box>
            <Box>
              {payment_note && (
                <>
                  <Typography
                    variant="body2"
                    className={`${classes.serviceList} ${classes.notesLabel}`}
                  >
                    <span className={classes.listLabel}>
                      Payment Note (not visible to customer):{' '}
                    </span>
                  </Typography>
                  <Typography variant="body2" className={classes.serviceList}>
                    {payment_note}
                  </Typography>
                </>
              )}
            </Box>
            <Box>
              {technician_note && (
                <>
                  <Typography
                    variant="body2"
                    className={`${classes.serviceList} ${classes.notesLabel}`}
                  >
                    <span className={classes.listLabel}>Technician Note: </span>
                  </Typography>
                  <Typography variant="body2" className={classes.serviceList}>
                    {technician_note}
                  </Typography>
                </>
              )}
            </Box>
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default UnifiedViewNotes;
